import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vignettesEdit_template } from "../components/templates/vignettesEdit_template";

declare var ko: any;
declare var page: any;

export class vignettes_edit extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: vignettesEdit_template;
    protected XHRHdlCaller: string;
    protected autosaveDelay: number = 120;
    protected autosaveTimeout: any = null;

    protected getModuleName(){
        return 'vignettes_edit';
    }

    buildContent() : Array<Element> {

        this.editForm = new vignettesEdit_template('editForm', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignettes Edit');

        return [this.editForm.build()];
    }

    public fillPage(): void {

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.editForm.setBrand(idBrand);
        }

        this.editForm.setupMonacoEditors();
        this.loadAvailableStylesheets();
        this.getFormData();
    }

    protected loadAvailableStylesheets(): void {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (!idBrand) {
            return;
        }

        let usrReq_url: string = `/api/brand/${idBrand}/vignette-stylesheets/get/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({
            pagination: { pageNumber: 1, itemPerPage: 500 },
            orderBy: "name",
            orderByDirection: "ASC",
            filters: { keyword: "", ownerBrandItems: [], idStatus: [] }
        })]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.onReadyStateFunction = (req, obj) => {
            return () => {
                obj.manageResponse(req, obj, () => {
                    const responseParsed = JSON.parse(req.request.response);
                    obj.editForm.setAvailableStylesheets(responseParsed.data || []);
                });
            };
        };
        XHRHdl.execute();
    }

    protected filterMultipleSelectorOnChange(): void {
        if (this.editForm && typeof this.editForm.updateCombinedPreviewCss === 'function') {
            this.editForm.updateCombinedPreviewCss();
        }
        this.startAutosave();
    }

    protected getFormData() {

        let idVignette = this.getVnAppZone().getApp().params.id;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        if(!idVignette || !idBrand) {
            return;
        }

        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = `/api/brand/${idBrand}/tags/vignettes/get/${idVignette}`;
        let usrReq_params: Array<Array<string>> = [];

        let vm:any = this.editForm.getViewModelForRequest();
        vm.lockItem = true;
        usrReq_params.push(["data", ko.toJSON(vm)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {

        return () => {
            try {
                obj.manageResponse(req, obj, () => {
                    const responseParsed = JSON.parse(req.request.response).data;
                    if (responseParsed.vignette) {
                        obj.editForm.setVignette(responseParsed.vignette);
                        if (!obj.editForm.getIsBrandOwner()) {
                            obj.cancel();
                            return;
                        }
                    }
                    obj.editForm.setPermissions(responseParsed.permissions);
                    obj.handleVignetteRecovery(responseParsed.recovery);
                });
            } catch (e) {
                console.error(e);
            }finally {
                obj.loadingOut(obj.editForm.builtTemplate);
            }
        }
    }

    public startAutosave(): void {
        if (this.autosaveTimeout) {
            clearTimeout(this.autosaveTimeout);
        }

        this.autosaveTimeout = setTimeout(() => {
            if (!window.location.pathname.includes('/categorization/vignettes/add') && !window.location.pathname.includes('/categorization/vignettes/edit')) {
                return;
            }

            this.saveRecoveryVignette();
        }, this.autosaveDelay * 1000);
    }

    protected clearAutosaveTimer(): void {
        if (this.autosaveTimeout) {
            clearTimeout(this.autosaveTimeout);
            this.autosaveTimeout = null;
        }
    }

    protected buildSaveRequestUrl(): string {
        let brandUrl = this.isBrand() ? `/brand/${this.getBrandId()}` : '';
        let url: string = `/api${brandUrl}/tags/vignettes/save/`;
        return url;
    }

    public isBrand(): boolean {
        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public saveVignette(actionSource: string = 'save') {
        this.clearAutosaveTimer();
        this.validationTemplate.clearMessages();

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        let htmlContent = subViewModel.html || "";
        let cssContent = subViewModel.css || "";
        let jsContent = subViewModel.js || "";
        
        const emptyTagsRegex = /<(style|script)\b[^>]*>[\s\r\n]*<\/\1>|<(style|script)\b[^>]*\/>/gi;
        const tagRegex = /<(style|script)\b[^>]*>/i;

        // Clean up empty tags first
        if (htmlContent) {
            htmlContent = htmlContent.replace(emptyTagsRegex, "");
            this.editForm.getTemplateViewModel().html(htmlContent);
            subViewModel.html = htmlContent;
        }
        if (jsContent) {
            jsContent = jsContent.replace(emptyTagsRegex, "");
            // Note: we update the VM/subViewModel below if we wrap it, otherwise we update it now
            this.editForm.getTemplateViewModel().js(jsContent);
            subViewModel.js = jsContent;
        }

        if (tagRegex.test(htmlContent)) {
            this.validationTemplate.setMessages([
                {
                    field: 'html',
                    label: 'Vignette',
                    messages: [
                        "Vignette can't be saved with &lt;style&gt; or &lt;script&gt; tags in the HTML field. &lt;style&gt; tags must be placed in the CSS field and &lt;script&gt; tags must be placed in the JS field."
                    ]
                }
            ]);
            window.scrollTo(0, 0);
            return;
        }

        // Apply Safeguards before saving
        if (cssContent) {
            cssContent = cssContent.replace(/<\/?style\b[^>]*>/gi, "").trim();
            this.editForm.getTemplateViewModel().css(cssContent);
            subViewModel.css = cssContent;
        }

        if (jsContent && jsContent.trim() !== "") {
            if (jsContent.toLowerCase().indexOf("<script") === -1) {
                jsContent = "<script>\n" + jsContent + "\n</script>";
                this.editForm.getTemplateViewModel().js(jsContent);
                subViewModel.js = jsContent;
            }
        }

        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        this.XHRHdlCaller = actionSource;
        let formReq_url: string = this.buildSaveRequestUrl();

        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(['data', ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.onSaveVignetteReturn;
        XHRHdl.execute();
    }

    protected onSaveVignetteReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.id) {
                    obj.editForm.setId(responseParsed.data.id);
                    obj.updateRouteAfterVignetteId(responseParsed.data.id, obj.XHRHdlCaller);
                }
                if (responseParsed.data && typeof responseParsed.data.idStatus !== 'undefined') {
                    obj.editForm.setIdStatus(responseParsed.data.idStatus);
                }

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'vignettes saved successfully!');
                if (obj.XHRHdlCaller !== 'stay') {
                    obj.releaseLock('save');
                } else {
                    obj.startAutosave();
                }
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected saveRecoveryVignette(): void {
        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        if (!subViewModel.id) {
            subViewModel.idStatus = 1;
        }

        this.editForm.setIsAutosaving(true);
        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(['data', ko.toJSON(subViewModel)]);

        let url = `/api/brand/${this.getBrandId()}/tags/vignettes/recovery/save/`;
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(url, formReq_params, this);
        (XHRHdl as any).__vignetteRecoverySavePathname = window.location.pathname;
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveRecoveryVignetteReturn;
        XHRHdl.execute();
    }

    protected onSaveRecoveryVignetteReturn(req, obj) {
        return function () {
            const pathname = (req as any).__vignetteRecoverySavePathname;
            if (pathname && pathname !== window.location.pathname) {
                obj.editForm.setIsAutosaving(false);
                return;
            }

            if (req.request.readyState === 4 && req.request.status === 200) {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.id) {
                    obj.editForm.setId(responseParsed.data.id);
                    obj.updateRouteAfterVignetteId(responseParsed.data.id, 'autosave');
                }
                if (responseParsed.data && responseParsed.data.name && !obj.editForm.getName()) {
                    obj.editForm.setName(responseParsed.data.name);
                }
                if (responseParsed.data && typeof responseParsed.data.idStatus !== 'undefined') {
                    obj.editForm.setIdStatus(responseParsed.data.idStatus);
                }
            }

            if (req.request.readyState === 4) {
                obj.editForm.setIsAutosaving(false);
                obj.startAutosave();
            }
        }
    }

    protected handleVignetteRecovery(recovery): void {
        if (!recovery || !recovery.content || !this.isRecoveryDifferent(recovery.content)) {
            return;
        }

        if (window.confirm("A newer autosaved copy of this vignette was found. Do you want to restore it?")) {
            this.editForm.setRecoveryContent(recovery.content);
            this.startAutosave();
        } else {
            this.deleteVignetteRecovery();
        }
    }

    protected isRecoveryDifferent(content): boolean {
        const current = this.editForm.getViewModelForRequest();

        return current.name !== content.name
            || current.html !== content.html
            || current.css !== content.css
            || current.js !== content.js
            || Number(current.idStatus) !== Number(content.idStatus)
            || JSON.stringify(current.stylesheetIds || []) !== JSON.stringify(content.stylesheetIds || content.stylesheets || []);
    }

    protected deleteVignetteRecovery(): void {
        if (!this.editForm.getId()) {
            return;
        }

        let url = `/api/brand/${this.getBrandId()}/tags/vignettes/recovery/delete/${this.editForm.getId()}/`;
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(url, [], this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.execute();
    }

    protected updateRouteAfterVignetteId(idVignette: number, actionSource: string): void {
        if (!idVignette || !window.location.pathname.includes('/categorization/vignettes/add')) {
            return;
        }

        if (actionSource === 'autosave' || actionSource === 'stay') {
            window.history.pushState(
                'vignette-edit',
                'Emaki CMS',
                `/brand/${this.getBrandId()}/categorization/vignettes/edit/${idVignette}`
            );
        }
    }

    private buildReleaseVignetteLockUrl() {
        let idVignette = this.getVnAppZone().getApp().params.id || this.editForm.getId();
        let url: string = `tags/vignettes/release/${idVignette}`;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let urlBrand = '';
        if (idBrand) {
            urlBrand = `brand/${idBrand}/`;
        }

        let endpoint: string = `/api/${urlBrand}${url}`;

        return endpoint;
    }

    protected releaseLock(actionSource: string) {

        // request a lock release
        let usrReq_url = this.buildReleaseVignetteLockUrl();

        this.XHRHdlCaller = actionSource;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPostRequestReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onPostRequestReleaseLockReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let redirectionUrl = obj.getVnAppZone().app.getLastRoute();
                if (obj.XHRHdlCaller === 'save') {
                    redirectionUrl = obj.buildListRequestUrl();
                } else if (obj.XHRHdlCaller === 'cancel') {
                    redirectionUrl = `/brand/${obj.getBrandId()}/categorization/vignettes/view/${obj.editForm.getId()}`;
                }

                page.redirect(redirectionUrl);
            });
        }
    }

    protected buildListRequestUrl(): string {

        let url = '/categorization/vignettes/';
        let brandUrl = this.isBrand() ? `/brand/${this.getBrandId()}` : '';

        return `${brandUrl}${url}`;
    }

    public copyToClipboardAlert(): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Copied To Clipboard');
        this.getVnAppZone().showNotificationToModule();
    }

    protected cancel() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idVignette = this.getVnAppZone().getApp().params.id;

        if(idVignette) {
            this.releaseLock('cancel');
        }
        else {
            page(`/brand/${idBrand}/categorization/vignettes`);
        }
    }

    protected getMemoryViewModel() {
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignettes_edit.ts